import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import './assets/sass/utilities.scss';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { FirebaseProvider } from './contexts/FirebaseContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { initializeHotjar } from './utilities/hotjarUtils';

// Initialize Hotjar (only runs if configured in environment)
initializeHotjar();

// Global error handlers (will be enhanced by ErrorContext when available)
window.addEventListener('error', (event) => {
  console.error('Global JavaScript error:', event.error);
  
  // Store error for later processing by ErrorContext
  if (!window.__PENDING_ERRORS__) {
    window.__PENDING_ERRORS__ = [];
  }
  window.__PENDING_ERRORS__.push({
    type: 'javascript_error',
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    timestamp: new Date().toISOString()
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  
  // Store error for later processing by ErrorContext
  if (!window.__PENDING_ERRORS__) {
    window.__PENDING_ERRORS__ = [];
  }
  window.__PENDING_ERRORS__.push({
    type: 'promise_rejection',
    reason: event.reason,
    promise: event.promise,
    timestamp: new Date().toISOString()
  });
  
  // Prevent the default browser console error
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <FirebaseProvider>
        <AuthProvider>
          <ErrorProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ErrorProvider>
        </AuthProvider>
      </FirebaseProvider>
    </ThemeProvider>
  </React.StrictMode>
);
